<wr-new-data-table
                   localStorageIdentifier="building-attachment-folder-overview"
                   [loadItemsFunction]="loadAttachmentFolders"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToRegion($event)"
                   [form]="form">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-items">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
        @if (canCreate()) {
          <button type="button" class="add-folder" nbButton status="primary" (click)="add()" [nbTooltip]="'Neuer Ordner'" nbTooltipPlacement="top">
            <nb-icon pack="eva" icon="plus-outline"></nb-icon>
          </button>
        }
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-region
    key="color"
    display="Farbe">
    <div class="color-swatch" [style.background]="region.color"></div>
  </ng-template>
  <ng-template
    dataColumn
    let-region
    key="name"
    display="Name">
    <div class="folder-name" data-cy="attachment-folder-name">
      <span>{{ region.name }}</span>
      <wr-private-folder-badge [publicFolder]="region.publicFolder"></wr-private-folder-badge>
    </div>
  </ng-template>
</wr-new-data-table>
